import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetAssesmentQuizByLink } from '@edtech-ui/core/models/assesment/get-assesment-by-quiz-id';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';
import { S3MultipartUploaderService } from '@edtech-ui/core/services/s3-multipart-uploader.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, firstValueFrom, interval, of, Subscription, tap } from 'rxjs';
import { AssesmentSuccessDialogBoxComponent } from '../assesment-success-dialog-box/assesment-success-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { SaveQuizProgressPayload } from '@edtech-ui/core/models/quiz-attempt/save-quiz-progress';
import { ProctoringRule } from '@edtech-ui/core/models/assesment/get-proctoring-config';
import { FaceDetectionService } from '../proctoring/services/face-detection.service.ts.service';
import { SnapshotServiceTsService } from '../proctoring/services/snapshot.service.ts.service';
import { ProctoringRuleEngineServiceTsService } from '../proctoring/engine/proctoring-rule-engine.service.ts.service';
import { ViolationStateServiceTsService } from '../proctoring/engine/violation-state.service.ts.service';
import { TabMonitorServiceTsService } from '../proctoring/services/tab-monitor.service.ts.service';
import { AudioDetectionServiceTsService } from '../proctoring/services/audio-detection.service.ts.service';
import { WarningBannerComponent } from '../proctoring/proto-ui/warning-banner/warning-banner.component';
import { ProctoringLogEventPayload } from '@edtech-ui/core/models/assesment/post-proctoring-log-event';
import { FullScreenService } from '../proctoring/full-screen/full-screen.service';
import { AssessmentProtoPopupComponent } from '../assessment-proto-popup/assessment-proto-popup.component';
import { MathLatexComponent } from '@edtech-ui/shared/latex/math-latex/math-latex.component';
import { QuestionBlocksComponent } from '@edtech-ui/shared/question-blocks/question-blocks.component';
import { cleanQuestionQuizOptionText } from '@edtech-ui/core/utils/assessment-quiz/assessment-quiz-question-option-no.utils';
import html2canvas from 'html2canvas';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { ResumeQuizAttemptResponse } from '@edtech-ui/core/models/quiz-attempt/get-quiz-resume';


@Component({
	selector: 'app-assesment-quiz-questions',
	standalone: true,
	imports: [CommonModule, WarningBannerComponent, MathLatexComponent, QuestionBlocksComponent],
	templateUrl: './assesment-quiz-questions.component.html',
	styleUrl: './assesment-quiz-questions.component.scss'
})
export class AssesmentQuizQuestionsComponent implements OnInit, AfterViewInit, OnDestroy {


	linkId: string | null = null;
	attemptId: string | null = null;
	subscription = new Subscription();
	assesmentData: GetAssesmentQuizByLink | null = null;
	currentQuestionIndex = 0;
	answers: Record<string, string> = {};
	lastSavedAnswers: string = '';
	isSubmitted = false;
	isSubmitting = false;
	remainingTime: number = 0;
	timerInterval: any;
	timerDisplay: string = '';
	quizId: string = '';
	reviewList: Set<string> = new Set();
	protoData: ProctoringRule[] = [];
	warningCount = 0;
	stream!: MediaStream;
	private readonly MAX_WARNINGS = 3;
	private readonly CHUNK_SIZE_BYTES = 10 * 1024 * 1024;
	private faceDetectionSub = new Subscription();
	private violationThrottle = new Map<string, number>();
	private readonly THROTTLE_MS = 5000;
	private mediaRecorder!: MediaRecorder;
	private recordedChunks: Blob[] = [];
	private audioCalibrationFrames: number[] = [];
	private calibrationDone = false;
	showFullscreenWarning = false;
	private audioBaseline = 0;
	@ViewChild('video', { static: false }) videoRef!: ElementRef<HTMLVideoElement>;
	private snapshotCanvas: HTMLCanvasElement = document.createElement('canvas');
	fullscreenViolationCount = 0;
	MAX_FULLSCREEN_VIOLATIONS = 3;
	isEvaluating = false;
	isAssessmentBlocked = false;
	private fullscreenSub = new Subscription();
	private compositeStream!: MediaStream;
	cleanQuestionQuizOptionText = cleanQuestionQuizOptionText;
	isFromStudentDashboard = false;
	isFromMockTest = false;
	isProctored = true;
	proctoringConfig: any = null;


	constructor(
		private quizService: QuizManagementService,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private dialog: MatDialog,
		private faceDetectService: FaceDetectionService,
		private snapshotService: SnapshotServiceTsService,
		private proctoringService: ProctoringRuleEngineServiceTsService,
		private violationService: ViolationStateServiceTsService,
		private tabMonitorService: TabMonitorServiceTsService,
		private audioDetectService: AudioDetectionServiceTsService,
		private fullScreenService: FullScreenService,
		private ngZone: NgZone,
		private router: Router,
		private s3Uploader: S3MultipartUploaderService
	) {
		const state = this.router.getCurrentNavigation()?.extras.state as any;
		if (state) {
			this.isProctored = state.is_proctored !== false;
			this.proctoringConfig = state.proctoring_config;
		}
	}


	ngOnInit(): void {
		this.isFromStudentDashboard = this.route.snapshot.queryParams['source'] === 'isStudentDashboard';
		this.isFromMockTest = this.route.snapshot.queryParams['fromMockTest'] === 'true';
		const attemptIdFromQuery = this.route.snapshot.queryParams['attemptId'];

		if (attemptIdFromQuery) {
			this.attemptId = attemptIdFromQuery;
			this.loadResumeQuizAttempt(attemptIdFromQuery);
		} else {
			this.subscription.add(
				this.route.paramMap.subscribe(paramMap => {
					this.linkId = paramMap.get('linkId');
					if (this.linkId && this.linkId !== 'resume') {
						this.startAttemptAssesmentQuiz();
					}
				})
			);
		}

		this.route.queryParams.subscribe(params => {
			this.isFromStudentDashboard = params['source'] === 'isStudentDashboard';
			this.isFromMockTest = params['fromMockTest'] === 'true';
		});
		this.getAssesmentProctoringConfig();

		setTimeout(() => {
			if (!this.fullScreenService.isFullscreen) {
				this.fullScreenService.enterFullscreen();
			}
		}, 500);

		if (this.isProctored) {
			this.fullScreenService.listenForExit();
			this.fullscreenSub = this.fullScreenService.escapeAttempt$.subscribe(() => {
				if (!this.isSubmitted) {
					this.handleFullscreenExit();
				}
			});
		}
	}

	loadResumeQuizAttempt(attemptId: string) {
		this.subscription.add(
			this.quizService.getQuizResumeAttempt(attemptId).pipe(
				tap((response: ResumeQuizAttemptResponse) => {
					if (!response?.Success && (response?.Status === 400 || response?.Message?.toLowerCase().includes('already submitted') || response?.Message?.toLowerCase().includes('completed'))) {
						this.stopAssessmentFlow();
						this.openReAttemptDialogBox();
						return;
					}

					if (response?.Success && response?.Data) {
						const data = response.Data;
						if (data.status === 'submitted' || data.status === 'Completed' || data.status === 'completed') {
							this.stopAssessmentFlow();
							this.openReAttemptDialogBox();
							return;
						}

						this.attemptId = data.attempt_id || attemptId;
						this.quizId = data.quiz_id;
						if (data.link_id) {
							this.linkId = data.link_id;
						}

						if ((data as any).is_proctored !== undefined) {
							this.isProctored = (data as any).is_proctored !== false;
						}

						this.assesmentData = {
							quiz_name: data.quiz_name,
							quiz_id: data.quiz_id,
							time_limit: data.time_limit,
							questions: (data.quiz_conversation || []).map((conv: any, idx: number) => ({
								...conv.questions,
								order: conv.questions?.order ?? (idx + 1)
							}))
						} as any;

						this.answers = {};
						(data.quiz_conversation || []).forEach((conv: any) => {
							if (conv.user_answer && conv.questions?.question_id) {
								const matchedOption = conv.questions.options?.find(
									(opt: any) => opt.option_id === conv.user_answer || opt.text === conv.user_answer
								);
								this.answers[conv.questions.question_id] = matchedOption ? matchedOption.option_id : conv.user_answer;
							}
							if (conv.is_marked_for_review || conv.questions?.needs_review) {
								this.reviewList.add(conv.questions.question_id);
							}
						});

						let remainingSeconds = (data.time_limit || 0) - (data.time_taken || 0);
						if (remainingSeconds < 0) remainingSeconds = 0;
						this.startTimer(remainingSeconds);

						// Automatically resume at the first unanswered question
						const firstUnansweredIndex = (this.assesmentData?.questions || []).findIndex(
							(q: any) => !this.answers[q.question_id]);
						this.currentQuestionIndex = firstUnansweredIndex !== -1 ? firstUnansweredIndex : 0;

						const answeredTotal = Object.keys(this.answers).length;
						const totalQuestions = this.assesmentData?.questions?.length || 0;
						this.startAutoRecording();
						this.startAutoSave();
					} else {
						this.toastr.error(response?.Message);
					}
				}),
				catchError((error: any) => {
					const errorResponse = error?.error;
					const errorMessage = errorResponse?.Message || error?.message || '';

					if (error?.status === 400 || errorMessage?.toLowerCase().includes('already submitted') || errorMessage?.toLowerCase().includes('completed')) {
						this.stopAssessmentFlow();
						this.openReAttemptDialogBox();
						return of(null);
					}

					this.toastr.error('Failed to load in-progress assessment attempt.');
					return of(null);
				})
			).subscribe()
		);
	}



	async ngAfterViewInit() {
		setTimeout(async () => {
			if (this.isAssessmentBlocked) return;
			try {
				if (this.isProctored) {
					if (this.proctoringConfig?.enable_camera !== false) {
						await this.initCamera();
					}
					await this.startFaceDetection();
				}
			} catch (err) {
				this.toastr.error('Camera/mic access denied');
			}
		}, 300);
	}


	handleFullscreenExit() {
		if (this.isSubmitted) return;
		if (this.isAssessmentBlocked) return;
		this.fullscreenViolationCount++;
		this.showFullscreenWarning = true;
		this.postProctoringLogEvent('FULLSCREEN_EXIT', 'WARNING');

		if (this.fullscreenViolationCount >= this.MAX_FULLSCREEN_VIOLATIONS) {
			this.showFullscreenWarning = false;
			this.toastr.error('Maximum fullscreen violations reached. Submitting...');
			setTimeout(() => this.submitTest(true), 2000);
		}
	}


	reEnterFullscreen() {
		this.showFullscreenWarning = false;
		this.fullScreenService.enterFullscreen();
	}


	getQuizByLinkId() {
		if (!this.linkId) return;
		this.subscription.add(
			this.quizService.getAssesmentQuizLinkById(this.linkId).pipe(
				tap(response => {
					if (response.Success) {
						this.assesmentData = response.Data;
						this.startTimer(response.Data.time_limit);
						this.quizId = response.Data.quiz_id;
						this.startAutoRecording();
						this.startAutoSave();
					}
				}),
				catchError(() => {
					return of(null);
				})
			).subscribe()
		)
	}


	startAttemptAssesmentQuiz() {
		if (!this.linkId) return;
		this.subscription.add(
			this.quizService.postAttemptAssesmentQuizLink(this.linkId).pipe(
				tap(response => {

					if (!response.Success && response.Data?.max_attempts_reached && response.Status === 400) {
						this.stopAssessmentFlow();
						this.openReAttemptDialogBox();
						return;
					}

					if (response.Success) {
						this.getQuizByLinkId()
						this.attemptId = response.Data.attempt_id || '';
					}

					if (!response.Success && response.Status === 400) {
						this.toastr.error(response.Message);
						this.stopAssessmentFlow();
						if (this.isFromMockTest) {
							this.router.navigate(['/student-dashboard/placement-prep'], { queryParams: { tab: 'history' } });
						} else if (this.isFromStudentDashboard) {
							this.router.navigate(['/student-dashboard/jobs/my-applications']);
						} else {
							localStorage.clear();
							this.router.navigate(['/']);
						}
						return;
					}
				}),
				catchError((error: any) => {
					const errorResponse = error?.error;

					if (error.status === 403) {
						this.stopAssessmentFlow();
						if (this.isFromMockTest) {
							this.router.navigate(['/student-dashboard/placement-prep'], { queryParams: { tab: 'history' } });
						} else if (this.isFromStudentDashboard) {
							this.router.navigate(['/student-dashboard/jobs/my-applications']);
						} else {
							localStorage.clear();
							this.router.navigate(['']);
						}
						return of(null);
					}
					if (errorResponse?.Data?.max_attempts_reached && errorResponse?.Status === 400) {
						this.stopAssessmentFlow();
						this.openReAttemptDialogBox();
						return of(null);
					}
					this.toastr.error('Something went wrong');
					return of(null);
				})
			).subscribe()
		)
	}


	startAutoSave() {
		this.subscription.add(
			interval(5000).subscribe(() => {
				if (this.isSubmitted || !this.attemptId || !this.assesmentData) return;
				this.saveQuizProgress();
			})
		);
	}


	saveQuizProgress() {
		if (!this.assesmentData?.questions || !this.attemptId) return;
		const currentAnswers = JSON.stringify(this.answers);
		if (this.lastSavedAnswers === currentAnswers) return;
		this.lastSavedAnswers = currentAnswers;
		const quizConversation = this.assesmentData.questions.map(q => ({
			questions: {
				question_id: q.question_id,
				question_type: q.question_type,
				difficulty_level: q.difficulty_level,
				question_text: q.question_text,
				options: q.options ?? [],
				marks: q.marks,
				order: q.order,
				is_ai: q.is_ai,
				topic: q.topic,
				subject: q.subject,
				sub_topics: q.sub_topics,
				section: q.section
			},
			user_answer: this.getOptionText(q, this.answers[q.question_id] ?? ''),
			is_skipped: !this.answers[q.question_id],
			is_marked_for_review: this.reviewList.has(q.question_id)
		}));

		const payload: SaveQuizProgressPayload = {
			attempt_id: this.attemptId,
			quiz_question_id: this.quizId,
			quiz_conversation: quizConversation
		};
		this.subscription.add(
			this.quizService.patchSaveQuizProgress(payload).subscribe()
		);
	}


	startTimer(seconds: number) {
		if (this.timerInterval) {
			clearInterval(this.timerInterval);
			this.timerInterval = null;
		}

		this.remainingTime = seconds;
		this.updateTimerDisplay();
		this.timerInterval = setInterval(() => {
			if (this.remainingTime > 0) {
				this.remainingTime--;
				this.updateTimerDisplay();
			} else {
				clearInterval(this.timerInterval);
				this.timerInterval = null;
				this.onTimeUp();
			}
		}, 1000);
	}



	updateTimerDisplay() {
		const hours = Math.floor(this.remainingTime / 3600);
		const minutes = Math.floor((this.remainingTime % 3600) / 60);
		const seconds = this.remainingTime % 60;
		this.timerDisplay = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
	}


	pad(value: number): string {
		return value < 10 ? '0' + value : value.toString();
	}


	onTimeUp() {
		if (this.isSubmitted) return;
		if (this.timerInterval) {
			clearInterval(this.timerInterval);
			this.timerInterval = null;
		}
		this.toastr.warning('Time is up! Test will be submitted automatically.');
		this.submitTest(true);
	}


	get currentQuestion() {
		return this.assesmentData?.questions?.[this.currentQuestionIndex];
	}


	isOptionSelected(questionId: string, optionId: string): boolean {
		return this.answers[questionId] === optionId;
	}


	getOptionLabel(index: number): string {
		return String.fromCharCode(65 + index);
	}


	shouldShowSubmitInFooter(): boolean {
		if (!this.assesmentData?.questions) return false;
		// Show Submit button in footer ONLY if it is the last question AND all questions are answered.
		// Otherwise, show "Save & Next" so they can circle back to unanswered questions.
		return this.currentQuestionIndex === this.assesmentData.questions.length - 1 && this.isAllAnswered;
	}


	async submitTest(forceSubmit: boolean = false) {
		if (this.isSubmitted || this.isSubmitting) return;
		if (!this.assesmentData || !this.attemptId) return;

		if (forceSubmit) {
			await this.executeSubmit();
			return;
		}

		// Open the Confirmation Dialog (Submit Pop-up)
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			data: {
				title: 'Submit Assessment',
				message: 'Are you sure you want to submit? You cannot change your answers after submission.',
				confirmText: 'Submit Now',
				cancelText: 'Continue Test',
				type: 'submit'
			},
			width: '400px'
		});

		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
				await this.executeSubmit();
			}
		});
	}


	private forceStopAllMediaTracks(): void {
		if (this.stream) {
			this.stream.getTracks().forEach(track => {
				track.stop();
				track.enabled = false;
			});
		}

		if (this.videoRef?.nativeElement) {
			this.videoRef.nativeElement.srcObject = null;
			this.videoRef.nativeElement.load();
		}

		const screenStream = this.proctoringService.getScreenStream();
		if (screenStream) {
			screenStream.getTracks().forEach(track => track.stop());
			this.proctoringService.clearScreenStream();
		}
	}

	buildEvaluatorPayload() {
		if (!this.assesmentData || !this.attemptId) return null;

		const quiz_conversation = this.assesmentData.questions.map(q => ({
			questions: {
				question_id: q.question_id,
				question_type: q.question_type,
				difficulty_level: q.difficulty_level,
				question_text: q.question_text,
				options: q.options ?? [],
				correct_answer: q.correct_answer ?? '',
				marks: q.marks,
				order: q.order,
				is_ai: q.is_ai,
				topic: q.topic,
				subject: q.subject,
				sub_topics: q.sub_topics,
				section: q.section
			},
			user_answer: this.getOptionText(q, this.answers[q.question_id] ?? ''),
			is_skipped: !this.answers[q.question_id],
			is_marked_for_review: this.reviewList.has(q.question_id),
			evaluation: {
				answer_type: this.getAnswerType(q),
				correct_answer: q.correct_answer ?? '',
				obtained_marks: this.getMarks(q),
				review: '',
				feedback: '',
				user_knowledge_level: this.getUserLevel(q)
			}
		}));

		const lastViolation = this.violationService.snapshot;
		return {
			attempt_id: this.attemptId,
			quiz_question_id: this.quizId, quiz_conversation,
			violation: {
				violation_type: lastViolation.currentWarning ?? '',
				image_url: '',
				details: `Total warnings: ${lastViolation.warningCount}`
			}
		};
	}


	getAnswerType(q: any): 'correct' | 'incorrect' | 'partial' | 'skipped' {
		const userAns = this.answers[q.question_id];

		if (!userAns) return 'skipped';

		if (q.correct_answer && userAns === q.correct_answer) {
			return 'correct';
		}

		return 'incorrect';
	}


	getUserLevel(q: any): 'beginner' | 'intermediate' | 'expert' {
		const answered = this.answers[q.question_id];
		const isCorrect = answered && answered === q.correct_answer;
		if (!answered || !isCorrect) return 'beginner';
		if (q.difficulty_level === 'Easy') return 'beginner';
		if (q.difficulty_level === 'Medium') return 'intermediate';
		return 'expert';
	}


	getMarks(q: any): number {
		const userAns = this.answers[q.question_id];

		if (userAns && q.correct_answer === userAns) {
			return q.marks;
		}

		return 0;
	}


	nextQuestion() {
		this.saveQuizProgress();

		if (!this.assesmentData?.questions) return;

		let foundNext = false;

		for (let i = this.currentQuestionIndex + 1; i < this.assesmentData.questions.length; i++) {
			const qId = this.assesmentData.questions[i].question_id;
			if (!this.answers[qId]) {
				this.goToQuestion(i);
				foundNext = true;
				break;
			}
		}

		if (!foundNext) {
			for (let i = 0; i < this.currentQuestionIndex; i++) {
				const qId = this.assesmentData.questions[i].question_id;
				if (!this.answers[qId]) {
					this.toastr.info('Cycling back to unanswered questions.');
					this.goToQuestion(i);
					foundNext = true;
					break;
				}
			}
		}

		if (!foundNext) {
			if (this.isAllAnswered) {
				this.toastr.success('You have answered all questions. Ready to submit?');
			} else {
				this.toastr.info('This is the last unanswered question.');
			}
		}
	}



	prevQuestion() {
		if (this.currentQuestionIndex > 0) {
			this.currentQuestionIndex--;
		}
	}


	goToQuestion(index: number) {
		this.currentQuestionIndex = index;
	}


	onSelectOption(questionId: string, optionId: string) {
		this.answers[questionId] = optionId;
	}


	onTextAnswer(questionId: string, event: any) {
		this.answers[questionId] = (event.target as HTMLInputElement).value;

	}


	clearAnswer(questionId: string) {
		delete this.answers[questionId];

	}


	toggleReview() {
		const qId = this.currentQuestion?.question_id;
		if (!qId) return;

		this.reviewList.has(qId)
			? this.reviewList.delete(qId)
			: this.reviewList.add(qId);
	}


	get answeredCount(): number {
		return Object.keys(this.answers).length;
	}


	get reviewCount(): number {
		return this.reviewList.size;
	}


	getQuestionStatus(questionId: string, index: number): string {
		if (this.currentQuestionIndex === index) {
			return 'current';
		}
		if (this.reviewList.has(questionId)) {
			return 'review';
		}
		if (this.answers[questionId]) {
			return 'answered';
		}
		return 'not-answered';
	}


	openAssesmentResult() {
		const dialogRef = this.dialog.open(AssesmentSuccessDialogBoxComponent, {
			disableClose: true,
			data: {
				title: this.assesmentData?.quiz_name,
				isFromStudentDashboard: this.isFromStudentDashboard,
				isFromMockTest: this.isFromMockTest
			}
		});

		dialogRef.afterClosed().subscribe(() => {
			this.cleanupMedia();
			this.subscription.unsubscribe();
		});
	}


	getAssesmentProctoringConfig() {
		this.quizService.getAssesmentProctoringConfig().pipe(
			tap(response => {
				if (response.Success) {
					let rules = response.Data.rules;
					if (this.proctoringConfig) {
						if (this.proctoringConfig.multiple_person_detection === false) {
							rules = rules.filter((r: any) => r.name !== 'MULTIPLE_FACES');
						}
						if (this.proctoringConfig.face_detection === false) {
							rules = rules.filter((r: any) => r.name !== 'NO_FACE');
						}
						if (this.proctoringConfig.eye_movement_tracking === false) {
							rules = rules.filter((r: any) => r.name !== 'LOOKING_AWAY');
						}
					}
					this.protoData = rules;
					this.proctoringService.setRules(this.protoData);
					if (response.Data.total_allowed_violation_count) {
						this.violationService.setMaxWarnings(response.Data.total_allowed_violation_count);
						this.MAX_FULLSCREEN_VIOLATIONS = response.Data.total_allowed_violation_count;
					}
				}
			})
		).subscribe()
	}


	async startAutoRecording(): Promise<void> {
		if (!this.isProctored) return;
		if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
			try { this.mediaRecorder.stop(); } catch (e) { }
		}
		this.recordedChunks = [];

		await new Promise<void>((resolve) => {
			const start = Date.now();
			const check = () => {
				if (this.stream && this.videoRef?.nativeElement?.readyState >= 2) {
					resolve();
				} else if (Date.now() - start > 5000) {
					resolve();
				} else {
					setTimeout(check, 100);
				}
			};
			check();
		});

		const screenStream = this.proctoringService.getScreenStream();
		const isLive = screenStream?.getVideoTracks()[0]?.readyState === 'live';

		if (screenStream && isLive) {
			this.startCompositeRecording(screenStream);
		} else {
			this.startWebcamOnlyRecording();
		}
	}


	private startCompositeRecording(screenStream: MediaStream): void {
		const canvas = document.createElement('canvas');
		canvas.width = 854;
		canvas.height = 480;
		const ctx = canvas.getContext('2d')!;

		const screenVideo = document.createElement('video');
		screenVideo.srcObject = screenStream;
		screenVideo.muted = true;
		screenVideo.onloadedmetadata = () => screenVideo.play();

		let animFrameId: number;

		this.ngZone.runOutsideAngular(() => {
			const drawFrame = () => {
				if (this.isSubmitted) {
					cancelAnimationFrame(animFrameId);
					return;
				}

				if (screenVideo.readyState >= 2 && screenVideo.videoWidth > 0) {
					ctx.drawImage(screenVideo, 0, 0, canvas.width, canvas.height);
				} else {
					ctx.fillStyle = '#111827';
					ctx.fillRect(0, 0, canvas.width, canvas.height);
				}

				animFrameId = requestAnimationFrame(drawFrame);
			};

			drawFrame();
		});
		this.compositeStream = canvas.captureStream(15);
		const canvasStream = this.compositeStream;
		if (this.stream) {
			this.stream.getAudioTracks().forEach(track => { canvasStream.addTrack(track) });
		}

		const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
			? 'video/webm;codecs=vp9'
			: MediaRecorder.isTypeSupported('video/webm;codecs=vp8')
				? 'video/webm;codecs=vp8'
				: 'video/webm';

		this.mediaRecorder = new MediaRecorder(canvasStream, { mimeType, videoBitsPerSecond: 500000 });

		this.mediaRecorder.ondataavailable = (e) => {
			if (e.data && e.data.size > 0) { this.recordedChunks.push(e.data) }
		};

		this.mediaRecorder.onstop = () => {
			cancelAnimationFrame(animFrameId);
			screenStream.getTracks().forEach(track => track.stop());
			screenVideo.srcObject = null;
		};

		this.mediaRecorder.start(1000);
	}


	private startWebcamOnlyRecording(): void {
		if (!this.stream) return;

		const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
			? 'video/webm;codecs=vp9'
			: 'video/webm';

		this.mediaRecorder = new MediaRecorder(this.stream, { mimeType, videoBitsPerSecond: 500_000 });
		this.mediaRecorder.ondataavailable = (e) => {
			if (e.data && e.data.size > 0) this.recordedChunks.push(e.data);
		};
		this.mediaRecorder.start(1000);
	}


	async initCamera(): Promise<void> {
		if (this.stream) {
			const activeTracks = this.stream.getTracks().some(t => t.readyState === 'live');
			if (activeTracks) {
				return;
			}
			this.stream = null as any;
		}

		this.stream = await navigator.mediaDevices.getUserMedia({
			video: {
				width: { ideal: 1280 },
				height: { ideal: 720 },
				facingMode: 'user'
			},
			audio: true
		});

		const video = this.videoRef?.nativeElement;
		if (!video) return;
		video.muted = true;
		video.srcObject = this.stream;

		await new Promise<void>((resolve) => {
			video.onloadedmetadata = () => {
				video.play();
				resolve();
			};
		});
	}


	stopAutoRecording(): Promise<Blob> {
		return new Promise((resolve) => {
			if (!this.mediaRecorder) {
				resolve(new Blob(this.recordedChunks, { type: 'video/webm' }));
				return;
			}

			const streamToStop = this.stream;
			const finalizeBlob = () => {
				const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
				if (streamToStop) {
					streamToStop.getTracks().forEach(track => {
						try { track.stop(); } catch (e) { }
					});
				}
				resolve(blob);
			};

			const originalOnStop = this.mediaRecorder.onstop;
			this.mediaRecorder.onstop = (e) => {
				if (originalOnStop) {
					try { originalOnStop.call(this.mediaRecorder, e); } catch (err) { }
				}
				finalizeBlob();
			};

			if (this.mediaRecorder.state !== 'inactive') {
				try {
					this.mediaRecorder.requestData();
				} catch (e) { }
				try {
					this.mediaRecorder.stop();
				} catch (e) {
					finalizeBlob();
				}
			} else {
				finalizeBlob();
			}
		});
	}


	private stopStream(stream: MediaStream | null): void {
		if (!stream) return;
		stream.getTracks().forEach(track => {
			try {
				track.stop();
			} catch {

			}
		});
	}


	async protoUserRecordingConfig(): Promise<void> {
		if (!this.attemptId) return;

		const videoBlob = await this.stopAutoRecording();
		if (!videoBlob || videoBlob.size === 0) return;

		const contentType = 'video/webm';
		const totalChunks = Math.ceil(videoBlob.size / this.CHUNK_SIZE_BYTES);

		try {
			let initiateRes: any;
			for (let attempt = 0; attempt < 3; attempt++) {
				try {
					initiateRes = await firstValueFrom(
						this.quizService.initiateMultipartUpload(this.attemptId, contentType));
					if (initiateRes?.Success) break;
				} catch (e) {
					if (attempt === 2) throw e;
					await new Promise(r => setTimeout(r, 2000 * Math.pow(2, attempt)));
				}
			}

			if (!initiateRes?.Success) {
				console.warn('Could not start recording upload.');
				return;
			}

			const uploadId: string = initiateRes.Data.upload_id;
			const objectKey: string = initiateRes.Data.object_key;

			const uploadedParts: any[] = [];

			const uploadOne = async (i: number): Promise<boolean> => {
				const start = i * this.CHUNK_SIZE_BYTES;
				const end = Math.min(start + this.CHUNK_SIZE_BYTES, videoBlob.size);
				const chunkBlob = videoBlob.slice(start, end);
				const partNumber = i + 1;

				const cacheId = await this.s3Uploader.cacheChunk(this.attemptId!, chunkBlob, partNumber);

				for (let attempt = 0; attempt < 4; attempt++) {
					try {
						const urlRes = await firstValueFrom(this.quizService.getMultipartPartUrl(this.attemptId!, uploadId, objectKey, partNumber));
						const presignedUrl = urlRes.Data.presigned_url;
						const etag = await this.s3Uploader.uploadPartToS3(presignedUrl, chunkBlob);

						uploadedParts.push({ PartNumber: partNumber, ETag: etag });
						await this.s3Uploader.removeCachedChunk(cacheId);
						return true;
					} catch (e) {
						console.warn(`[MediaRecorder] Chunk ${partNumber} upload failed (Attempt ${attempt + 1}/4):`, e);
						if (attempt === 3) return false;
						await new Promise(r => setTimeout(r, 2000 * Math.pow(2, attempt)));
					}
				}
				return false;
			};

			for (let i = 0; i < totalChunks; i++) {
				const success = await uploadOne(i);
				if (!success) {
					console.warn('Recording upload chunk failed after retries. Will remain in IndexedDB.');
					return;
				}
			}

			if (uploadedParts.length === totalChunks) {
				uploadedParts.sort((a, b) => a.PartNumber - b.PartNumber);
				await firstValueFrom(this.quizService.completeMultipartUpload(this.attemptId!, uploadId, objectKey, uploadedParts));
			}
		} catch (e) {
			console.error('Quiz video recording upload failed:', e);
		}
	}
	async postSnapshotAssesmentQuiz(
		videoElement: HTMLVideoElement,
		violationType: string,
		severity: 'CRITICAL' | 'WARNING',
		reason: string
	): Promise<void> {
		if (!this.attemptId || !videoElement || videoElement.readyState < 2) return;

		try {
			const pageCanvas = await html2canvas(document.body, {
				useCORS: true,
				allowTaint: true,
				scale: 0.8,
				width: window.innerWidth,
				height: window.innerHeight,
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight,
				x: window.scrollX,
				y: window.scrollY,
				ignoreElements: (el) => el.classList.contains('camera-box')
			});

			const finalCanvas = document.createElement('canvas');
			finalCanvas.width = window.innerWidth;
			finalCanvas.height = window.innerHeight;
			const ctx = finalCanvas.getContext('2d')!;
			ctx.drawImage(pageCanvas, 0, 0, finalCanvas.width, finalCanvas.height);

			const camW = 220;
			const camH = Math.round((videoElement.videoHeight / videoElement.videoWidth) * camW);
			const padding = 20;
			const x = finalCanvas.width - camW - padding;
			const y = finalCanvas.height - camH - padding;

			ctx.save();
			ctx.beginPath();
			ctx.roundRect(x, y, camW, camH, 12);
			ctx.clip();
			ctx.drawImage(videoElement, x, y, camW, camH);
			ctx.restore();
			ctx.strokeStyle = '#7c3aed';
			ctx.lineWidth = 3;
			ctx.beginPath();
			ctx.roundRect(x, y, camW, camH, 12);
			ctx.stroke();
			ctx.fillStyle = 'rgba(124,58,237,0.85)';
			ctx.fillRect(x, y + camH - 24, 44, 24);
			ctx.fillStyle = '#ffffff';
			ctx.font = 'bold 11px Inter, sans-serif';
			ctx.fillText('YOU', x + 8, y + camH - 7);
			finalCanvas.toBlob((blob) => {
				if (!blob) return;
				const payload = {
					attempt_id: this.attemptId!,
					image: blob,
					is_violation: true,
					violation_type: violationType,
					severity,
					reason,
					violation_count: this.warningCount
				};
				this.quizService.postSnapshot(payload).subscribe();
			}, 'image/jpeg', 0.8);

		} catch (err) {
			console.error('Snapshot failed', err);
		}
	}


	triggerViolation(type: string): void {
		const video = this.videoRef?.nativeElement;
		if (!video || !this.attemptId || this.isSubmitted) return;

		const now = Date.now();
		const last = this.violationThrottle.get(type) || 0;

		if (now - last < this.THROTTLE_MS) return;
		this.violationThrottle.set(type, now);

		const warningCount = this.violationService.snapshot.warningCount;
		const severity: 'CRITICAL' | 'WARNING' = warningCount >= this.MAX_WARNINGS ? 'CRITICAL' : 'WARNING';

		this.toastr.warning(`Warning ${this.warningCount}/${this.MAX_WARNINGS}: ${type}`);
		this.postSnapshotAssesmentQuiz(video, type, severity, `Violation detected: ${type}`);
	}


	async startFaceDetection(): Promise<void> {
		const video = this.videoRef?.nativeElement;
		if (!video || !this.stream) {
			if (this.proctoringConfig?.enable_camera !== false) {
				this.toastr.error('Video or stream not ready');
			}
			return;
		}

		if (this.proctoringConfig?.face_detection !== false) {
			await this.faceDetectService.start(video);
		}

		if (this.proctoringConfig?.no_talking_detection !== false) {
			await this.audioDetectService.start(this.stream);
		}

		if (this.proctoringConfig?.detect_tab_switch !== false) {
			this.tabMonitorService.start();
		}


		this.faceDetectionSub.add(
			this.tabMonitorService.tabSwitch$.subscribe(() => {
				if (this.proctoringConfig?.detect_tab_switch !== false) {
					this.violationService.trigger('TAB_SWITCH', 'CRITICAL');
				}
			})
		);


		this.faceDetectionSub.add(
			this.audioDetectService.energy$.subscribe(energy => {
				if (this.proctoringConfig?.no_talking_detection !== false) {
					this.handleAudioEnergy(energy);
				}
			})
		);


		this.faceDetectionSub.add(
			this.faceDetectService.detections$.subscribe(detections => {
				if (this.isSubmitted) return;
				if (this.proctoringConfig?.face_detection !== false || this.proctoringConfig?.multiple_person_detection !== false || this.proctoringConfig?.eye_movement_tracking !== false) {
					this.proctoringService.evaluate(detections);
				}
			})
		);


		this.faceDetectionSub.add(
			this.violationService.state$.subscribe(state => {

				if (state.currentWarning && this.attemptId && !this.isSubmitted) {
					const CRITICAL_TYPES = ['TAB_SWITCH'];
					const severity: 'CRITICAL' | 'WARNING' = CRITICAL_TYPES.includes(state.currentWarning)
						? 'CRITICAL'
						: 'WARNING';

					this.warningCount = state.warningCount;

					const video = this.videoRef?.nativeElement;
					if (video) {
						const now = Date.now();
						const last = this.violationThrottle.get(state.currentWarning) || 0;

						if (now - last >= this.THROTTLE_MS) {
							this.violationThrottle.set(state.currentWarning, now);
							this.postProctoringLogEvent(state.currentWarning, severity);
							this.postSnapshotAssesmentQuiz(
								video,
								state.currentWarning,
								severity,
								`Violation detected: ${state.currentWarning}`
							);

						}
					}
				}

				if (state.isTerminated && !this.isSubmitted) {
					this.toastr.error('Too many violations! Submitting in 3 seconds...');
					setTimeout(() => {
						this.violationService.clearTermination();
						this.submitTest(true);
					}, 3000);
				}
			})
		);
	}


	private handleAudioEnergy(energy: number): void {
		if (this.isSubmitted) return;

		if (!this.calibrationDone) {
			this.audioCalibrationFrames.push(energy);
			if (this.audioCalibrationFrames.length >= 20) {
				const sorted = [...this.audioCalibrationFrames].sort((a, b) => a - b);
				this.audioBaseline = sorted[Math.floor(sorted.length / 2)];
				this.calibrationDone = true;
			}
			return;
		}

		if (this.audioBaseline >= 0 && energy > this.audioBaseline * 1.5) {
			this.violationService.trigger('BACKGROUND_VOICE', 'WARNING');
		}
	}


	postProctoringLogEvent(eventType: string, severity: 'CRITICAL' | 'WARNING') {

		const payload: ProctoringLogEventPayload = {
			attempt_id: this.attemptId,
			event_type: eventType,
			severity: severity,
			details: `Violation detected: ${eventType}`,
			timestamp: new Date().toISOString()
		}

		this.subscription.add(
			this.quizService.postProctoringLogEvent(payload).pipe(
				catchError(() => of(null))
			).subscribe()
		);
	}


	cleanupMedia(): void {
		this.showFullscreenWarning = false;
		this.fullscreenSub.unsubscribe();
		this.fullScreenService.cleanup();

		this.faceDetectService.stop();
		this.audioDetectService.stop?.();
		this.tabMonitorService.stop?.();
		this.violationThrottle.clear();
		this.violationService.reset?.();
		this.warningCount = 0;

		if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
			this.mediaRecorder.stop();
		}

		const screenStream = this.proctoringService.getScreenStream();
		if (screenStream) {
			this.stopStream(screenStream);
			this.proctoringService.clearScreenStream();
		}

		this.stopStream(this.stream);
		this.stream = null as any;
		this.recordedChunks = [];
		this.mediaRecorder = null as any;

		if (this.videoRef?.nativeElement) {
			const videoEl = this.videoRef.nativeElement;
			if (videoEl.srcObject instanceof MediaStream) {
				this.stopStream(videoEl.srcObject as MediaStream);
			}
			videoEl.srcObject = null;
			videoEl.load();
		}

		if (document.fullscreenElement) {
			document.exitFullscreen().catch(() => { });
		}
	}


	get isFullscreen(): boolean {
		return !!document.fullscreenElement;
	}


	getOptionText(q: any, optionId: string): string {
		if (!optionId) return '';
		const option = (q.options ?? []).find((o: any) => o.option_id === optionId);
		return option?.text ?? '';
	}


	openReAttemptDialogBox() {
		const dialogRef = this.dialog.open(AssessmentProtoPopupComponent, {
			disableClose: true,
			data: {
				isFromStudentDashboard: this.isFromStudentDashboard,
				isFromMockTest: this.isFromMockTest
			}
		});

		dialogRef.afterClosed().subscribe(() => {
			this.cleanupMedia();
			this.subscription.unsubscribe();
		})
	}


	stopAssessmentFlow() {
		this.isAssessmentBlocked = true;
		this.assesmentData = null;
		if (this.timerInterval) {
			clearInterval(this.timerInterval);
			this.timerInterval = null;
		}
		this.faceDetectionSub.unsubscribe();

		this.faceDetectService.stop();
		this.audioDetectService.stop?.();
		this.tabMonitorService.stop?.();

		if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
			this.mediaRecorder.ondataavailable = null as any;
			this.mediaRecorder.onstop = null as any;

			this.mediaRecorder.stop();
		}

		if (this.stream) {
			this.stream.getTracks().forEach(track => track.stop());
			this.stream = null as any;
		}

		if (this.videoRef?.nativeElement) {
			this.videoRef.nativeElement.srcObject = null;
			this.videoRef.nativeElement.load();
		}

		const screenStream = this.proctoringService.getScreenStream();

		if (screenStream) {
			screenStream.getTracks().forEach(track => track.stop());
			this.proctoringService.clearScreenStream();
		}

		setTimeout(() => {
			if (document.fullscreenElement) {
				document.exitFullscreen().catch(() => { });
			}
		}, 100);
	}



	get isAllAnswered(): boolean {
		return !!this.assesmentData?.questions && this.answeredCount === this.assesmentData.questions.length;
	}

	private async executeSubmit() {
		this.isSubmitted = true;
		this.isSubmitting = true;

		clearInterval(this.timerInterval);
		this.saveQuizProgress();

		this.faceDetectionSub.unsubscribe();
		this.faceDetectionSub = new Subscription();
		this.faceDetectService.stop();
		this.audioDetectService.stop?.();
		this.tabMonitorService.stop?.();

		if (this.isProctored) {
			try {
				await Promise.race([
					this.protoUserRecordingConfig(),
					new Promise<void>((_, reject) => setTimeout(() => reject(new Error('timeout')), 300000))
				]);
			} catch (err) {
				console.warn('Recording upload skipped or timed out:', err);
			}
		}

		this.cleanupMedia();

		const payload = this.buildEvaluatorPayload();
		if (!payload) {
			this.isSubmitting = false;
			return;
		}

		this.isEvaluating = true;

		try {
			await firstValueFrom(this.quizService.postAIQuestionsEvaluator(payload));
			this.toastr.success('Test submitted successfully');

			if (!this.isFromStudentDashboard) {
				localStorage.clear();
			}
			this.openAssesmentResult();
		} catch {
			this.toastr.error('Evaluation failed');
		} finally {
			this.isEvaluating = false;
			this.isSubmitting = false;
		}
	}

	ngOnDestroy(): void {
		this.cleanupMedia();
		this.fullscreenSub.unsubscribe();
		this.subscription.unsubscribe();
		this.faceDetectionSub.unsubscribe();
		if (this.timerInterval) {
			clearInterval(this.timerInterval);
		}
	}

}